import React from 'react';
import { Alert, Col, Row, Spinner } from 'reactstrap';
import NumberFormat from 'react-number-format';
import CardSummary from '../../../UI/cards/CardSummary';

const IndicatorsStats = ({
  statsLoading,
  statsError,
  statsEmpty,
  totals,
  selectedMetric,
  onSelectMetric,
}) => {
  const renderValue = (value) =>
    statsLoading ? <Spinner size="sm" /> : <NumberFormat value={value} displayType="text" thousandSeparator />;

  const cards = [
    { key: 'debtsToPay', title: 'Cuentas por pagar', color: 'danger', value: totals.debtsToPay },
    { key: 'receivables', title: 'Efectos por cobrar', color: 'warning', value: totals.receivables },
    { key: 'ownerPayments', title: 'Pagos de propietarios', color: 'success', value: totals.ownerPayments },
    { key: 'visitors', title: 'Visitantes', color: 'info', value: totals.visitors },
    { key: 'commonAreaReservations', title: 'Reservas de áreas comunes', color: 'primary', value: totals.commonAreaReservations },
  ];

  return (
    <>
      <Row>
        {cards.map((card) => (
          <Col key={card.key} md={6} xl={card.key === 'commonAreaReservations' || card.key === 'visitors' ? 6 : 4} className="mb-3">
            <div
              role="button"
              tabIndex={0}
              onClick={() => onSelectMetric(card.key)}
              onKeyDown={(e) => e.key === 'Enter' && onSelectMetric(card.key)}
              className={selectedMetric === card.key ? 'rounded border border-primary' : 'rounded'}
              style={{ cursor: 'pointer' }}
            >
              <div className="mb-n3">
                <CardSummary title={card.title} rate="Total condominios" color={card.color} linkText={null}>
                  {renderValue(card.value)}
                </CardSummary>
              </div>
            </div>
          </Col>
        ))}
      </Row>
      {statsError && (
        <Alert color="danger" className="mb-3">
          No pudimos cargar los indicadores en este momento. Intenta nuevamente en unos segundos.
        </Alert>
      )}
      {!statsLoading && !statsError && statsEmpty && (
        <Alert color="info" className="mb-3">
          Aun no hay actividad registrada para los filtros seleccionados.
        </Alert>
      )}
    </>
  );
};

export default IndicatorsStats;